import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { isDevelopment } from '@/lib/utils/environment';

const firebaseConfig = {
  apiKey: 'AIzaSyAu_WrUSjpyWL5XWOeyjmM1fxx5-o3KHSc',
  authDomain: 'convertology-b1d5b.firebaseapp.com',
  projectId: 'convertology-b1d5b',
  storageBucket: 'convertology-b1d5b.firebasestorage.app',
  messagingSenderId: '649137950644',
  appId: '1:649137950644:web:a821109dd3881e91446ce1',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const db = getFirestore(app);
export const auth = getAuth(app);

// Enable offline persistence
if (typeof window !== 'undefined') {
  try {
    const { enableIndexedDbPersistence } = require('firebase/firestore');
    enableIndexedDbPersistence(db).catch((err) => {
      if (err.code === 'failed-precondition') {
        console.warn(
          'Multiple tabs open, persistence can only be enabled in one tab at a time.'
        );
      } else if (err.code === 'unimplemented') {
        console.warn("The current browser doesn't support persistence.");
      }
    });
  } catch (error) {
    console.warn('Failed to enable persistence:', error);
  }
}

// Connect to emulators in development
if (false) {
  try {
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectAuthEmulator(auth, 'http://localhost:9099');
  } catch (error) {
    console.warn('Failed to connect to emulators:', error);
  }
}

export default app;
